'use client';

import * as React from 'react';
import Image from 'next/image';
import { Star } from 'lucide-react';
import { motion } from 'motion/react';

import { APP_NAME } from '@workspace/common/app';
import { cn } from '@workspace/ui/lib/utils';

import { GridSection } from '~/components/fragments/grid-section';
import { Marquee } from '~/components/fragments/marquee';

const DATA = [
  {
    name: 'Alexandru Dragomir',
    role: 'Antreprenor',
    img: 'https://randomuser.me/api/portraits/men/91.jpg',
    description: (
      <p>
        Am închiriat un BMW M4 pentru un weekend în Brașov și a fost o
        experiență perfectă.{' '}
        <strong>
          Mașina a fost în stare impecabilă iar procesul de preluare foarte
          simplu.
        </strong>{' '}
        Recomand cu încredere!
      </p>
    )
  },
  {
    name: 'Diana Popescu',
    role: 'Manager Marketing',
    img: 'https://randomuser.me/api/portraits/women/12.jpg',
    description: (
      <p>
        Pentru nunta noastră am ales un Mercedes S-Class de la {APP_NAME}.{' '}
        <strong>Șoferul a fost extrem de profesionist și punctual.</strong>{' '}
        Servicii premium fără compromisuri.
      </p>
    )
  },
  {
    name: 'Mihai Ionescu',
    role: 'Director Executiv',
    img: 'https://randomuser.me/api/portraits/men/45.jpg',
    description: (
      <p>
        Folosesc {APP_NAME} pentru călătoriile de afaceri în București.{' '}
        <strong>Flotă diversificată și customer service excelent.</strong>{' '}
        Apreciez flexibilitatea și atenția la detalii.
      </p>
    )
  },
  {
    name: 'Elena Radu',
    role: 'Arhitect',
    img: 'https://randomuser.me/api/portraits/women/83.jpg',
    description: (
      <p>
        Am închiriat un Range Rover pentru o excursie în Delta Dunării.{' '}
        <strong>
          Mașina a fost exact ce aveam nevoie pentru drumurile dificile.
        </strong>{' '}
        Prețuri corecte pentru servicii de calitate.
      </p>
    )
  },
  {
    name: 'Andrei Munteanu',
    role: 'Fotograf',
    img: 'https://randomuser.me/api/portraits/men/1.jpg',
    description: (
      <p>
        Pentru ședințele foto am nevoie de mașini care să impresioneze.{' '}
        <strong>
          {APP_NAME} mi-a oferit mereu opțiuni premium cu livrare la locație.
        </strong>{' '}
        Colaborare excelentă de fiecare dată.
      </p>
    )
  },
  {
    name: 'Maria Constantin',
    role: 'Medic specialist',
    img: 'https://randomuser.me/api/portraits/women/5.jpg',
    description: (
      <p>
        Am rezervat o Tesla pentru un weekend la mare.{' '}
        <strong>
          Totul a decurs perfect și mașina a fost curată și încărcată complet.
        </strong>{' '}
        Apreciez seriozitatea și profesionalismul echipei.
      </p>
    )
  },
  {
    name: 'Bogdan Stanescu',
    role: 'Avocat',
    img: 'https://randomuser.me/api/portraits/men/14.jpg',
    description: (
      <p>
        Pentru impresie în fața clienților, aleg mereu {APP_NAME}.{' '}
        <strong>
          Berlinele lor de lux sunt întotdeauna în stare perfectă.
        </strong>{' '}
        Serviciu de 5 stele, de fiecare dată.
      </p>
    )
  },
  {
    name: 'Cristina Neagu',
    role: 'Consultant Financiar',
    img: 'https://randomuser.me/api/portraits/women/56.jpg',
    description: (
      <p>
        Folosesc serviciile {APP_NAME} lunar.{' '}
        <strong>
          Apreciez varietatea de mașini și condițiile transparente.
        </strong>{' '}
        Întreg procesul de închiriere este foarte eficient.
      </p>
    )
  },
  {
    name: 'Alexandru Dragomir',
    role: 'Antreprenor',
    img: 'https://randomuser.me/api/portraits/men/91.jpg',
    description: (
      <p>
        Am închiriat un BMW M4 pentru un weekend în Brașov și a fost o
        experiență perfectă.{' '}
        <strong>
          Mașina a fost în stare impecabilă iar procesul de preluare foarte
          simplu.
        </strong>{' '}
        Recomand cu încredere!
      </p>
    )
  },
  {
    name: 'Diana Popescu',
    role: 'Manager Marketing',
    img: 'https://randomuser.me/api/portraits/women/12.jpg',
    description: (
      <p>
        Pentru nunta noastră am ales un Mercedes S-Class de la {APP_NAME}.{' '}
        <strong>Șoferul a fost extrem de profesionist și punctual.</strong>{' '}
        Servicii premium fără compromisuri.
      </p>
    )
  },
  {
    name: 'Mihai Ionescu',
    role: 'Director Executiv',
    img: 'https://randomuser.me/api/portraits/men/45.jpg',
    description: (
      <p>
        Folosesc {APP_NAME} pentru călătoriile de afaceri în București.{' '}
        <strong>Flotă diversificată și customer service excelent.</strong>{' '}
        Apreciez flexibilitatea și atenția la detalii.
      </p>
    )
  },
  {
    name: 'Elena Radu',
    role: 'Arhitect',
    img: 'https://randomuser.me/api/portraits/women/83.jpg',
    description: (
      <p>
        Am închiriat un Range Rover pentru o excursie în Delta Dunării.{' '}
        <strong>
          Mașina a fost exact ce aveam nevoie pentru drumurile dificile.
        </strong>{' '}
        Prețuri corecte pentru servicii de calitate.
      </p>
    )
  },
  {
    name: 'Gabriel Marinescu',
    role: 'Inginer IT',
    img: 'https://randomuser.me/api/portraits/men/32.jpg',
    description: (
      <p>
        După accident, nu știam că am dreptul la mașină de înlocuire RCA.{' '}
        <strong>
          {APP_NAME} m-a ajutat să obțin o BMW Seria 5 complet gratuită.
        </strong>{' '}
        Serviciu impecabil și toate formalitățile rezolvate profesional.
      </p>
    )
  },
  {
    name: 'Raluca Voicu',
    role: 'Jurnalist',
    img: 'https://randomuser.me/api/portraits/women/74.jpg',
    description: (
      <p>
        În loc de o mașină obișnuită RCA, am primit un Mercedes de lux.{' '}
        <strong>
          Echipa {APP_NAME} a gestionat totul cu asigurarea, fără costuri.
        </strong>{' '}
        Excelent serviciu pentru cei care cunosc drepturile legale.
      </p>
    )
  }
];

export function Testimonials(): React.JSX.Element {
  return (
    <GridSection hideVerticalGridLines>
      <div className="container border-x py-20 md:border-none">
        <h2 className="mb-8 text-center text-3xl font-semibold md:text-5xl lg:text-left">
          Ce spun clienții noștri
        </h2>
        <div className="relative mt-6 max-h-[640px] overflow-hidden">
          <div className="gap-4 md:columns-2 xl:columns-3 2xl:columns-4">
            {Array(Math.ceil(DATA.length / 3))
              .fill(0)
              .map((_, i) => (
                <Marquee
                  vertical
                  key={i}
                  className={cn({
                    '[--duration:60s]': i === 1,
                    '[--duration:30s]': i === 2,
                    '[--duration:70s]': i === 3
                  })}
                >
                  {DATA.slice(i * 3, (i + 1) * 3).map((testimonial, index) => (
                    <motion.div
                      key={index}
                      initial={{ opacity: 0 }}
                      whileInView={{ opacity: 1 }}
                      viewport={{ once: true }}
                      transition={{
                        delay: Math.random() * 0.4,
                        duration: 1
                      }}
                      className="mb-4 flex w-full break-inside-avoid flex-col items-center justify-between gap-6 rounded-xl border bg-background p-4 dark:[border:1px_solid_rgba(255,255,255,.1)] dark:[box-shadow:0_-20px_80px_-20px_#ffffff1f_inset]"
                    >
                      <div className="select-none text-sm font-normal text-muted-foreground">
                        {testimonial.description}
                        <div className="flex flex-row py-1">
                          <Star className="size-4 fill-yellow-500 text-yellow-500" />
                          <Star className="size-4 fill-yellow-500 text-yellow-500" />
                          <Star className="size-4 fill-yellow-500 text-yellow-500" />
                          <Star className="size-4 fill-yellow-500 text-yellow-500" />
                          <Star className="size-4 fill-yellow-500 text-yellow-500" />
                        </div>
                      </div>
                      <div className="flex w-full select-none items-center justify-start gap-5">
                        <Image
                          width={40}
                          height={40}
                          src={testimonial.img || ''}
                          alt={testimonial.name}
                          className="size-8 rounded-full ring-1 ring-border ring-offset-4"
                        />
                        <div>
                          <p className="text-sm font-medium">
                            {testimonial.name}
                          </p>
                          <p className="text-xs font-normal text-muted-foreground">
                            {testimonial.role}
                          </p>
                        </div>
                      </div>
                    </motion.div>
                  ))}
                </Marquee>
              ))}
          </div>
          <div className="pointer-events-none absolute inset-x-0 bottom-0 h-1/4 w-full bg-linear-to-t from-background from-20%" />
          <div className="pointer-events-none absolute inset-x-0 top-0 h-1/4 w-full bg-linear-to-b from-background from-20%" />
        </div>
      </div>
    </GridSection>
  );
}
